import { lazy } from "react";

const routes = [
  {
    path: "/organizationtype",
    element: lazy(() => import("../pages/OrganizationType")),
  },
  {
    path: "/organizationtype/add",
    element: lazy(() => import("../pages/OrganizationType/create")),
  },
  {
    path: "/organizationtype/edit/:id",
    element: lazy(() => import("../pages/OrganizationType/edit")),
  },
];

export default routes;
